import { dispenserQueries } from '@/features/dispensers/queries.ts';
import { useQuery } from '@tanstack/react-query';
import {
  DISPENSER_GRID_CONFIG,
  getColumns,
} from '@/features/dispensers/components/dispenser-list/config.tsx';
import { GridState } from '@/common/api/sieveAdapter.ts';
import { AppDataGrid } from '@/common/components/app-data-grid/AppDataGrid.tsx';

export interface DispenserListProps {
  gridState: GridState;
  onGridStateChange: (gridState: GridState) => void;
}

export const DispenserList = ({ gridState, onGridStateChange }: DispenserListProps) => {
  const { data, isLoading, refetch, isError } = useQuery(dispenserQueries.list(gridState));

  return (
    <AppDataGrid
      config={DISPENSER_GRID_CONFIG}
      columns={getColumns()}
      list={data}
      loading={isLoading}
      gridState={gridState}
      onGridStateChange={onGridStateChange}
      disableRowSelectionOnClick
      onRefetch={refetch}
      dataFetchError={isError}
    />
  );
};
